<template>
  <a-card :style="{ width: '300px', margin: '16px' }">
    <div style="display: flex; justify-content: center; align-items: center">
      <div>
         <div>
          <span v-if="capital"> 首都 {{ capital }} </span>
          <span v-else>&nbsp;</span> <!-- 保留一行高度，避免跳格 -->
        </div>
        <div >時區 {{ city }}</div>
        <!-- <div>{{ getCountryFromTimezone(props.timezone) }} {{ country }}</div> -->
        <div style="color: #024d73; font-weight: bold">{{ utcOffset }}</div>
        <div style="font-size: 1.75em">{{ time }}</div>
        <div>{{ date }}</div>
      </div>
    </div>
  </a-card>
</template>

<script setup>
import { ref, onMounted,computed } from "vue";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ClockCircleOutlined } from "@ant-design/icons-vue";
import timezoneCountryMap from "@/assets/data/timezone-country-map";

const capitalTimezoneMap = {
  "Asia/Tokyo": "Tokyo",
  "Asia/Ho_Chi_Minh": "Hanoi",
  "Asia/Seoul": "Seoul",
  "Australia/Sydney": "Canberra",
  "Pacific/Auckland": "Wellington",
  "Asia/Singapore": "Singapore",
  "Asia/Bangkok": "Bangkok",
  "America/New_York": "Washington",
  "America/Toronto": "Ottawa",
  "Europe/London": "London",
  "Europe/Berlin": "Berlin",
  "Europe/Dublin": "Dublin",
  "Europe/Bratislava": "Bratislava",
  "Europe/Warsaw": "Warsaw",
  "Europe/Budapest": "Budapest",
  "Europe/Vienna": "Vienna",
  "Europe/Prague": "Prague",
  "Europe/Paris": "Paris",
  "Europe/Luxembourg": "Luxembourg",
  "Europe/Amsterdam": "Amsterdam",
  "Europe/Brussels": "Brussels"
};

dayjs.extend(utc);
dayjs.extend(timezone);

// Props
const props = defineProps({
  city: String,
  country: String,
  timezone: String,
});

const time = ref("");
const date = ref("");
const utcOffset = ref("");

// 更新時間函式
const updateTime = () => {
  const now = dayjs().tz(props.timezone);
  time.value = now.format("HH:mm");
  date.value = now.format("YYYY/MM/DD dddd");
  utcOffset.value = "UTC" + now.format("Z"); // e.g. UTC-05:00
};
const getCountryFromTimezone = (tz) => {
  return timezoneCountryMap[tz] || "Unknown";
};
const capital = computed(() => {
  return capitalTimezoneMap[props.timezone] || null;
});
onMounted(() => {
  updateTime();
  setInterval(updateTime, 10000);
});
</script>
